export default "__VITE_ASSET__B7UXcdg9__"